import { motion } from "framer-motion"
import cc from "classcat"

const CardFlip = ({ children, flipped, className }) => {
  const variants = {
    flipped: { rotateY: 180 },
    normal: { rotateY: 0 },
  }

  return (
    <motion.div
      initial="normal"
      animate={flipped ? "flipped" : "normal"}
      variants={variants}
      transition={{ duration: 0.5 }}
      style={{ backfaceVisibility: "hidden" }}
    >
      {children}
    </motion.div>
  )
}

export default CardFlip
